import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { useContext } from 'react'
import { AuthContext } from '../AuthContext'
import { ArrowDownCircleIcon } from '@heroicons/react/24/solid'
import StaffNav from '../staff/staffnav'



function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function ManagerNav() {
  

  

  const user = useContext(AuthContext)

  if (String(user?.access || '').toLowerCase() === 'staff') {
    return <StaffNav />
  }


  const navigation = [
    { name: 'Dashboard', href: '/dashboard', current: true, feature: 'nav_dashboard' },
    { name: 'Chat', href: '/chatdashboard', current: false, feature: 'nav_chat' },
    { name: 'Finances', href: '/finances', current: false, feature: 'nav_finances' },
    { name: 'Projects', href: '/project-management', current: false, feature: 'nav_projects' },
    { name: 'Tasks', href: '/team-tasks', current: false, feature: 'nav_tasks' },
    { name: 'Back To Work', href: '/back-to-work', current: false, feature: 'nav_back_to_work' },
    { name: 'Recruitment', href: '/recruitment', current: false, feature: 'nav_recruitment' },
    { name: 'Training', href: '/training', current: false, feature: 'nav_training' },
    { name: 'Settings', href: '/billing', current: false, feature: 'nav_settings' },
  ]
  



  return (
    <Disclosure as="nav" className="bg-gradient-to-r from-indigo-900 from-10% via-sky-500 via-30% to-emerald-500 to-90%">
      <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
        <div className="relative flex h-16 items-center justify-between">
          <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                  <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                    <span className="absolute -inset-0.5" />
                    <span className="sr-only">Open main menu</span>
                    <Bars3Icon aria-hidden="true" className="block size-6 group-data-[open]:hidden" />
                    <XMarkIcon aria-hidden="true" className="hidden size-6 group-data-[open]:block" />
                  </DisclosureButton>
                  </div>
                  <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                  <div className="flex shrink-0 items-center">
                    <img
                    alt="Your Company"
                    src="2.png"
                    className="h-10 w-10 rounded-full object-cover bg-gray-900"
                    />
                  </div>
                  <div className="hidden sm:ml-6 sm:block">
                    <div className="flex space-x-4">
                    {navigation.map((item) => (
                      <a
                      key={item.name}
                      href={item.href}
                      aria-current={item.current ? 'page' : undefined}
                      data-component="manager-nav-link"
                      data-feature={item.feature}
                      className={classNames(
                        item.current ? 'bg-gray-900 text-white' : 'text-white hover:bg-gray-700 hover:text-white',
                        'rounded-md px-3 py-2 text-sm font-medium',
                      )}
                      >
                      {item.name}
                      </a>
                    ))}
                    
                    </div>
                  
                     
                  
                  </div>
                  </div>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                  

                  {/* Profile dropdown */}
            <Menu as="div" className="relative ml-3">
              <div>
                <MenuButton className="relative flex rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                  <span className="absolute -inset-1.5" />
                  <span className="sr-only">Open user menu</span>
                  <ArrowDownCircleIcon className="size-10 text-white" aria-hidden="true"
                  />
                </MenuButton>
              </div>
              <MenuItems
                transition
                className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
              >
                <MenuItem>
                  <a
                    href="/myprofile"
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:outline-none"
                  >
                    Your Profile
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="/billing"
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:outline-none"
                  >
                    Settings
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="/logout"
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:outline-none"
                  >
                    Sign out
                  </a>
                </MenuItem>
              </MenuItems>
            </Menu>
          </div>
        </div>
      </div>

      <DisclosurePanel className="sm:hidden">
        <div className="space-y-1 px-2 pb-3 pt-2">
          {navigation.map((item) => (
            <DisclosureButton
              key={item.name}
              as="a"
              href={item.href}
              aria-current={item.current ? 'page' : undefined}
              data-component="manager-mobile-nav-link"
              data-feature={item.feature}
              className={classNames(
                item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                'block rounded-md px-3 py-2 text-base font-medium',
              )}
            >
              {item.name}
            </DisclosureButton>
          ))}
        </div>
      </DisclosurePanel>
    </Disclosure>
  )
}
